import axios from "axios";
import { DataGrid, SelectBox, Toolbar } from "devextreme-react";
import {
  Column,
  Editing,
  Scrolling,
  StateStoring,
} from "devextreme-react/data-grid";
import { Item } from "devextreme-react/toolbar";
import ArrayStore from "devextreme/data/array_store";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
// import ColorComponent from "../ContractRegistration/ColorComponent";

export default function ProjectListComponent(props) {
  const {
    resourceDataSource,
    setResourceDataSource,
    // currentEmployeeNo,
    currentEmployee,
    // setCurrentEmployeeNo,
    schedulerRef,
    // selectedContrNos,
    setSelectedContrNos,
  } = props;

  const userInfo = useSelector((state) => state.userInfo);

  const [dataSource, setDataSource] = useState(null);

  const dataGridRef = useRef(null);
  // const [currentEmployeeNo, setCurrentEmployeeNo] = useState(
  //   userInfo.employeeNo
  // );

  // useEffect(() => {
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_BECCO_API_URL}/api/employee?div=${userInfo.div}`
  //     )
  //     .then((result) => {
  //       setDataSource(
  //         new ArrayStore({
  //           data: result.data,
  //           key: "employeeNo",
  //         })
  //       );
  //     });
  // }, []);

  // useEffect(async () => {
  //   try {
  //     const result = await axios.get(
  //       // `${process.env.REACT_APP_BECCO_API_URL}/api/contrReg?employeeNo=${currentEmployeeNo}`
  //       `${process.env.REACT_APP_BECCO_API_URL}/api/contrReg?employeeNo=${currentEmployee.employeeNo}`
  //     );

  //     console.debug("currentEmployee.employeeNo", currentEmployee.employeeNo);
  //     console.debug("resourceData", result.data);

  //     setResourceDataSource(result.data);

  //     // dataGridRef.current.instance.selectAll();
  //   } catch (error) {
  //     console.error(error);
  //   }
  //   // }, [currentEmployeeNo]);
  // }, [currentEmployee.employeeNo]);

  const cellRender = (data) => {
    return (
      <div
        // className="dx-colorbox-color-result-preview"
        style={{
          backgroundColor: data.data.color,
          left: "13px",
          width: "17px",
          height: "17px",
          border: "1px solid",
          borderColor: "#e0e0e0",
        }}
      >
        {/* {data.data.color} */}
      </div>
    );
  };

  const displayExpr = (item) => {
    if (item) {
      return `${item.name} (${item.employeeNo})`;
    } else {
      return null;
    }
  };

  // const onValueChanged = (e) => {
  //   setCurrentEmployeeNo(e.value.employeeNo);
  // };

  return (
    <React.Fragment>
      {/* {userInfo.resp && (
        <SelectBox
          dataSource={dataSource}
          // defaultValue={userInfo.employeeNo}
          defaultValue={currentEmployeeNo}
          displayExpr={displayExpr}
          onValueChanged={onValueChanged}
        />
      )} */}
      <Toolbar>
        <Item location="before">
          <span
            style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
          >
            PROJECT LIST
          </span>
        </Item>
      </Toolbar>
      <DataGrid
        ref={dataGridRef}
        keyExpr={"id"}
        dataSource={resourceDataSource}
        hoverStateEnabled={true}
        height="100%"
        showBorders={true}
        showColumnLine={true}
        showColumnHeaders={false}
        // onSelectionChanged={onSelectionChanged}
      >
        {/* <Selection mode={"single"} /> */}
        <Scrolling mode={"virtual"} showScrollbar="always" />

        {/* <Editing mode={"cell"} allowUpdating={true} /> */}

        {/* <Selection
          mode={"multiple"}
          selectAllMode="allPages"
          showCheckBoxesMode={"always"}
        /> */}

        <StateStoring
          enabled={true}
          type="localStorage"
          storageKey={"WorkingTimeTable.WorkRecord.ProjectListComponent"}
        />
        <Column
          dataField={"color"}
          cellRender={cellRender}
          width={30}
          // editCellComponent={ColorComponent}
        />
        <Column
          dataField={"id"}
          width={150}
          allowEditing={false}
          visible={false}
        />
        <Column dataField={"text"} allowEditing={false} visible={false} />
        <Column dataField={"name"} allowEditing={false} />
      </DataGrid>
    </React.Fragment>
  );
}
